import React from 'react'
import ContentCards from '@/components/content-cards'
import {ContentCardsProps} from '@/components/content-cards/types'

export const contentCardsBuilder = (props: ContentCardsProps) => {
    return <ContentCards {...props} data-testid={'content-cards-component'} />
}

export const contentCardsBuilderDefinition = {
    component: contentCardsBuilder,
    name: 'contentCards',

    inputs: [
        {
            name: 'heading',
            type: 'richText',
            defaultValue: 'Heading',
            helperText: 'The heading for the content cards section.'
        },
        {
            name: 'text',
            type: 'richText',
            defaultValue: 'This is a sample text for the content cards section.',
            helperText: 'The text for the content cards section.'
        },
        {
            name: 'ctaText',
            type: 'string',
            defaultValue: 'Shop Now',
            helperText: 'The call to action text for the content cards section.'
        },
        {
            name: 'buttonColor',
            type: 'color',
            helperText: 'The button color for the call to action button.'
        },
        {
            name: 'external',
            type: 'boolean',
            defaultValue: false,
            helperText: 'Set to true if the link is external.'
        },
        {
            name: 'external_link',
            type: 'reference',
            model: 'external-links',
            showIf: `options.get('external') === true`,
            helperText: 'The external link for the call to action button.'
        },
        {
            name: 'link',
            type: 'reference',
            model: 'page',
            showIf: `options.get('external') === false`,
            helperText: 'The internal link for the call to action button.'
        },
        {
            name: 'contentCard',
            type: 'list',
            subFields: [
                {
                    name: 'overlayImage',
                    type: 'file',
                    helperText: 'The overlay image for the card.'
                },
                {
                    name: 'overlayImagePosition',
                    type: 'string',
                    enum: [
                        'top',
                        'top-left',
                        'top-right',
                        'center',
                        'center-left',
                        'center-right',
                        'bottom',
                        'bottom-left',
                        'bottom-right'
                    ],
                    defaultValue: 'center',
                    helperText: 'The position of the overlay image.'
                },
                {
                    name: 'backgroundImageType',
                    type: 'string',
                    enum: ['color', 'image'],
                    defaultValue: 'color',
                    helperText: 'The type of background for the card.'
                },
                {
                    name: 'backgroundColor',
                    type: 'string',
                    showIf: `options.get('backgroundImageType') === 'color'`,
                    defaultValue: '#FFFFFF',
                    helperText: 'The background color for the card.'
                },
                {
                    name: 'backgroundImage',
                    type: 'file',
                    showIf: `options.get('backgroundImageType') === 'image'`,
                    helperText: 'The background image for the card.'
                },
                {
                    name: 'external',
                    type: 'boolean',
                    defaultValue: false,
                    helperText: 'Set to true if the link is external.'
                },
                {
                    name: 'external_link',
                    type: 'reference',
                    model: 'external-links',
                    showIf: `options.get('external') === true`,
                    helperText: 'The external link for the column item.'
                },
                {
                    name: 'link',
                    type: 'reference',
                    model: 'page',
                    showIf: `options.get('external') === false`,
                    helperText: 'The internal link for the column item.'
                },

                {
                    name: 'text',
                    type: 'longText',
                    helperText: 'The text for the column item.'
                },
                {
                    name: 'ctaText',
                    type: 'text',
                    helperText: 'The call to action text for the column item.'
                }
            ],
            helperText: 'The array of items to display in the category columns.'
        }
    ]
}

export default contentCardsBuilder
